import { render, staticRenderFns } from "./crosscountryshipmentreport.vue?vue&type=template&id=c6b743da&"
import script from "./crosscountryshipmentreport.vue?vue&type=script&lang=js&"
export * from "./crosscountryshipmentreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports